<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Campaign Histories</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Campaign Histories
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Campaign Histories</h4>
                </div>

                <div class="card-body">
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allCampaignHistories"
                        ref="myTable"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import PaginationMixin from "../../../Shared/Mixins/PaginationMixin";
import {formatDateTime} from "../../../utils";

export default {
    metaInfo: {title: 'Campaign Histories'},
    props: [
        'campaignHistories',
    ],
    layout: Layout,
    components: {
        Link,
    },
    mixins: [
        PaginationMixin,
    ],
    data() {
        return {
            filter: {},
            isLoadingFilter: false,
            allCampaignHistories: [],
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10
            },

            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },

            sortingOptions: {
                enabled: false,
            },

            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Campaign Title', field: 'title', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Campaign Description', field: 'description', thClass: 'text-center', tdClass: 'text-center',},
                {label: 'Campaign Channel', field: 'channel', thClass: 'text-center', tdClass: 'text-center',},
                {label: 'Sent By', field: 'sent_by', thClass: 'text-center', tdClass: 'text-center',},
                {label: 'Time Dispatched', field: 'created_at', thClass: 'text-center', tdClass: 'text-center', formatFn: formatDateTime},
            ],
            tableDataLoading: false,
        }
    },

    mounted() {
        this.allCampaignHistories = this.campaignHistories.data;
        this.totalRecords = this.campaignHistories.total
    },

    methods: {

        async paginatedData() {
            try {
                let routeName = 'admin.campaigns.campaign-history';

                let response = await axios.get(route(routeName,(this.allCampaignHistories[0].campaign_id ?? "")), {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allCampaignHistories = response.data.data
            } catch (e) {
                console.log(e);
            }
        },
    }
}
</script>
